// Original Shopify photographs only. Keep controls separate from the product button.
const SOLITAIRE_COLOR_DELAY=1200;
const colorImageCache=new Map();
function preloadColorImage(src){
  if(!colorImageCache.has(src)){
    const ready=new Promise(resolve=>{
      const image=new Image();
      image.decoding='async';
      image.onload=async()=>{try{await image.decode()}catch{}resolve(image.naturalWidth>0)};
      image.onerror=()=>resolve(false);
      image.src=src;
    });
    colorImageCache.set(src,ready);
  }
  return colorImageCache.get(src);
}
function setupColorPreview(card,product){
  const colors=product.colorImages;
  const photo=card.querySelector('.product-photo img');
  const reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)');
  const hoverPointer=window.matchMedia('(hover: hover) and (pointer: fine)');
  const controls=document.createElement('div');
  controls.className='product-colors';
  const group=document.createElement('div');
  group.className='gold-swatches';
  group.setAttribute('role','group');
  group.setAttribute('aria-label',`${product.name} gold color`);
  const label=document.createElement('span');
  label.className='gold-color-label';
  label.textContent=colors[0].label;
  const announcement=document.createElement('span');
  announcement.className='visually-hidden';
  announcement.setAttribute('aria-live','polite');
  announcement.setAttribute('aria-atomic','true');
  controls.append(group,label,announcement);
  card.append(controls);
  let current=0,baseline=0,timer=null,epoch=0,request=0,hovering=false,disposed=false;
  const buttons=colors.map((color,index)=>{
    const button=document.createElement('button');
    button.type='button';
    button.className=`gold-swatch gold-swatch-${color.key}`;
    button.setAttribute('aria-label',`Show ${product.name} in ${color.label}`);
    button.setAttribute('aria-pressed',String(index===0));
    button.title=color.label;
    button.innerHTML='<span aria-hidden="true"></span>';
    button.addEventListener('click',()=>selectColor(index));
    button.addEventListener('keydown',event=>{
      let target;
      if(event.key==='ArrowRight'||event.key==='ArrowDown')target=(index+1)%colors.length;
      else if(event.key==='ArrowLeft'||event.key==='ArrowUp')target=(index+colors.length-1)%colors.length;
      else if(event.key==='Home')target=0;
      else if(event.key==='End')target=colors.length-1;
      else return;
      event.preventDefault();buttons[target].focus();selectColor(target);
    });
    group.append(button);
    return button;
  });
  photo.alt=colors[0].alt;
  card.dataset.color=colors[0].key;
  const preload=()=>Promise.all(colors.map(color=>preloadColorImage(color.image)));
  async function display(index,announce=false){
    const ticket=++request;
    const color=colors[index];
    const ready=await preloadColorImage(color.image);
    if(disposed||ticket!==request)return false;
    if(!ready){
      if(announce)announcement.textContent=`${color.label} photo is unavailable. Open the product for more details.`;
      return false;
    }
    photo.src=color.image;
    photo.alt=color.alt;
    current=index;
    card.dataset.color=color.key;
    label.textContent=color.label;
    buttons.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));
    if(announce)announcement.textContent=`Showing ${product.name} in ${color.label}.`;
    return true;
  }
  function stop(reset=true){
    hovering=false;
    epoch++;
    request++;
    clearTimeout(timer);timer=null;
    if(reset&&!disposed)display(baseline);
  }
  async function selectColor(index){
    stop(false);
    preload();
    if(await display(index,true))baseline=index;
  }
  function active(run){
    return !disposed&&hovering&&run===epoch&&!document.hidden&&!reducedMotion.matches&&hoverPointer.matches&&card.isConnected;
  }
  function schedule(run){
    timer=setTimeout(async()=>{
      if(!active(run))return;
      await display((current+1)%colors.length);
      if(active(run))schedule(run);
    },SOLITAIRE_COLOR_DELAY);
  }
  function enter(event){
    if(event.pointerType!=='mouse'||reducedMotion.matches||!hoverPointer.matches)return;
    stop(false);
    hovering=true;
    const run=epoch;
    preload().then(()=>{if(active(run))schedule(run)});
  }
  const leave=event=>{if(event.pointerType==='mouse')stop()};
  const focus=()=>{stop(false);preload()};
  const visibility=()=>{if(document.hidden)stop()};
  const motionChange=()=>stop();
  card.addEventListener('pointerenter',enter);
  card.addEventListener('pointerleave',leave);
  card.addEventListener('focusin',focus);
  document.addEventListener('visibilitychange',visibility);
  reducedMotion.addEventListener('change',motionChange);
  hoverPointer.addEventListener('change',motionChange);
  // Warm all three photos just before the card comes into view, without layout changes.
  const observer='IntersectionObserver' in window?new IntersectionObserver(entries=>{
    if(entries.some(entry=>entry.isIntersecting))preload();
    else stop();
  },{rootMargin:'300px'}):null;
  if(observer)observer.observe(card);else preload();
  return {
    currentColor:()=>colors[current],
    stop,
    dispose(){
      disposed=true;stop(false);observer?.disconnect();
      document.removeEventListener('visibilitychange',visibility);
      reducedMotion.removeEventListener('change',motionChange);
      hoverPointer.removeEventListener('change',motionChange);
      card.removeEventListener('pointerenter',enter);
      card.removeEventListener('pointerleave',leave);
      card.removeEventListener('focusin',focus);
    }
  };
}
